import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames, scrollBar } from '../../utils/functions';
import { Color as PColor } from '../../utils/types/palette';
import { Shadows as PShadows } from '../../utils/types/shadows';
import { FontVariant as FV } from '../../utils/types/typography/font-variant';
import Accordion from '../accordion/accordion.component';
import AccordionHeaderStyled from '../accordion-header/accordion-header.styles';
import AccordionDetailsStyled from '../accordion-details/accordion-details.styles';
var baseClassName = 'Drawer';
var TemporaryDrawer = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'temporary')
}).withConfig({
  componentId: "sc-1riasfx-0"
})(function (_ref) {
  var open = _ref.open;
  return css(["position:absolute;inset:0px;z-index:1200;visibility:", ";"], !open && 'hidden');
});
var PersistentDrawer = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'persistent')
}).withConfig({
  componentId: "sc-1riasfx-1"
})([""]);
var Drawer = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-1riasfx-2"
})(function (_ref2) {
  var open = _ref2.open,
    isCollapsed = _ref2.isCollapsed,
    _ref2$top = _ref2.top,
    top = _ref2$top === void 0 ? 0 : _ref2$top,
    _ref2$theme = _ref2.theme,
    palette = _ref2$theme.palette,
    shadows = _ref2$theme.shadows,
    breakpoints = _ref2$theme.breakpoints;
  return css(["display:flex;flex-direction:column;flex:1 0 auto;background-color:", ";box-shadow:", ";overflow-y:overlay;overflow-x:hidden;transform:", ";visibility:", ";transition:200ms;height:calc(100% - ", "px);", "{margin-top:0px;height:100%;}", " &{margin-top:0px;height:100%;}box-sizing:border-box;width:", ";padding:", ";", ""], palette[PColor.BackgroundStateless], shadows[PShadows.LeftPanelMd], open ? 'none' : 'translateX(-100%)', !open && 'hidden', top, breakpoints.down('md'), breakpoints.classes.sm, isCollapsed ? '68px' : '302px', isCollapsed && '0px 12px', scrollBar);
});
var Header = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'header')
}).withConfig({
  componentId: "sc-1riasfx-3"
})(function (_ref3) {
  var isCollapsed = _ref3.isCollapsed;
  return css(["display:", ";justify-content:flex-start;align-items:center;position:relative;text-decoration:none;width:100%;box-sizing:border-box;text-align:left;margin-top:12px;transition:background-color 100ms ease-out;"], isCollapsed ? 'none' : 'flex');
});
var Body = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'body')
}).withConfig({
  componentId: "sc-1riasfx-4"
})(["flex:1 1 auto;.SfxAccordionDetails-root{margin:0;}"]);
var Footer = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'footer')
}).withConfig({
  componentId: "sc-1riasfx-5"
})(function (_ref4) {
  var isCollapsed = _ref4.isCollapsed;
  return css(["display:flex;flex-direction:column;width:100%;padding:", ";"], isCollapsed ? '0px' : '0px 8px');
});
var List = /*#__PURE__*/styled.ul.attrs({
  className: generateClassNames(baseClassName, 'list')
}).withConfig({
  componentId: "sc-1riasfx-6"
})(function () {
  return css(["list-style:none;margin:12px 0;padding:0;position:relative;"]);
});
var Item = /*#__PURE__*/styled.li.attrs({
  className: generateClassNames(baseClassName, 'item')
}).withConfig({
  componentId: "sc-1riasfx-7"
})(function (_ref5) {
  var palette = _ref5.theme.palette,
    isCollapsed = _ref5.isCollapsed,
    selected = _ref5.selected;
  return css(["display:", ";justify-content:flex-start;align-items:center;position:relative;text-decoration:none;width:100%;box-sizing:border-box;text-align:left;padding:13px 16px;transition:background-color 100ms ease-out;margin-bottom:4px;cursor:pointer;&:hover{background-color:", ";& > *{color:", ";}}", ""], isCollapsed ? 'none' : 'flex', palette[PColor.BackgroundActive], palette[PColor.AccentStateless], selected && css(["background-color:", ";& > *{color:", " !important;}"], palette[PColor.BackgroundActive], palette[PColor.AccentStateless]));
});
var ItemText = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'text')
}).withConfig({
  componentId: "sc-1riasfx-8"
})(function (_ref6) {
  var _ref6$theme = _ref6.theme,
    palette = _ref6$theme.palette,
    font = _ref6$theme.typography.font,
    fontKey = _ref6.font,
    isCollapsed = _ref6.isCollapsed;
  return css(["flex:1 1 auto;color:", ";", ";transition:color 100ms ease-out;display:", ";user-select:none;"], palette[PColor.TextPrimary], font[fontKey || FV.LabelLarge], isCollapsed && 'none');
});
var Icon = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'icon')
}).withConfig({
  componentId: "sc-1riasfx-9"
})(function (_ref7) {
  var palette = _ref7.theme.palette,
    isCollapsed = _ref7.isCollapsed;
  return css(["display:flex;flex-shrink:0;color:", ";margin-right:", ";transition:color 100ms ease-out;"], palette[PColor.IconsPrimary], isCollapsed ? '0px' : '12px');
});
var ItemButton = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'item-button')
}).withConfig({
  componentId: "sc-1riasfx-10"
})(function (_ref8) {
  var palette = _ref8.theme.palette,
    isCollapsed = _ref8.isCollapsed,
    selected = _ref8.selected;
  return css(["display:flex;justify-content:", ";align-items:center;border-radius:4px;box-sizing:border-box;text-align:left;padding:", ";transition:background-color 150ms cubic-bezier(0.4,0,0.2,1) 0ms;margin-bottom:8px;cursor:pointer;&:hover{background-color:", ";& > *{color:", ";}}", ""], isCollapsed ? 'center' : 'flex-start', isCollapsed ? '13px' : '13px 16px', palette[PColor.BackgroundActive], palette[PColor.AccentStateless], selected && css(["background-color:", ";& > *{color:", ";}"], palette[PColor.BackgroundActive], palette[PColor.AccentStateless]));
});
var CollapsedButton = /*#__PURE__*/styled(ItemButton).attrs({
  className: generateClassNames(baseClassName, 'item-button')
}).withConfig({
  componentId: "sc-1riasfx-11"
})(function (_ref9) {
  var isCollapsed = _ref9.isCollapsed;
  return css(["", ""], !isCollapsed && css(["padding:13px 24px;"]));
});
var DrawerAccordion = /*#__PURE__*/styled(Accordion).attrs({
  className: generateClassNames(baseClassName, 'accordion')
}).withConfig({
  componentId: "sc-1riasfx-12"
})(function (_ref10) {
  var _ref10$theme = _ref10.theme,
    palette = _ref10$theme.palette,
    font = _ref10$theme.typography.font,
    selected = _ref10.selected;
  return css(["", "{padding:13px 16px;transition:background-color 100ms ease-out;", "{", ";color:", ";}&:hover{background-color:", ";& > *{color:", ";}}", "}", "{padding:0px 16px;}"], AccordionHeaderStyled.Header, AccordionHeaderStyled.Label, font[FV.LabelLargeEmphasis], palette[PColor.TextPrimary], palette[PColor.BackgroundActive], palette[PColor.AccentStateless], selected && css(["", "{color:", ";}"], AccordionHeaderStyled.Label, palette[PColor.AccentStateless]), AccordionDetailsStyled.AccordionDetails);
});
var Styled = applyDisplayNames({
  TemporaryDrawer: TemporaryDrawer,
  PersistentDrawer: PersistentDrawer,
  Drawer: Drawer,
  Header: Header,
  Body: Body,
  Footer: Footer,
  List: List,
  Item: Item,
  ItemButton: ItemButton,
  Icon: Icon,
  ItemText: ItemText,
  DrawerAccordion: DrawerAccordion,
  CollapsedButton: CollapsedButton
});
export default Styled;